import { Box, Stack, Typography } from "@mui/material";
import { DebugBox, LoadingBox, useNavigateWithParams } from "@northpowerdev/np-react-utils";
import { plural } from "../../../utils/utilityFunctions";
import useFetchJson from "../../../data/useFetchJson";
import { hikoAlert } from "../../../utils/HikoAlert";
import { StyledDataGrid } from "./DlspStyledDataGrid";
import { useEffect } from "react";
import { AssigneeSelect } from "./AssigneeSelect";
import { useGetParams } from "../../../utils/useGetParams";
import { useState } from "react";


const gridColumns = [
    { field: 'stormArea',    headerName: 'Storm Area',       flex: 1 },
    { field: 'Total',        headerName: 'Total',            flex: 1, headerClassName: 'total',                valueGetter: (params) => getTotal(params) },
    { field: 'Desktop',      headerName: 'Desktop',          flex: 1, headerClassName: 'status-desktop',       valueGetter: (params) => getByStatus(params, 'Desktop') },
    { field: 'Desktop QA',   headerName: 'Desktop QA',       flex: 1, headerClassName: 'status-desktop-qa',    valueGetter: (params) => getByStatus(params, 'Desktop QA') },
    { field: 'Field',        headerName: 'Field',            flex: 1, headerClassName: 'status-field',         valueGetter: (params) => getByStatus(params, 'Field') },
    { field: 'Field QA',     headerName: 'Field QA',         flex: 1, headerClassName: 'status-field-qa',      valueGetter: (params) => getByStatus(params, 'Field QA') },
    { field: 'Remedial',     headerName: 'Remedial',         flex: 1, headerClassName: 'status-remedial',      valueGetter: (params) => getByStatus(params, 'Remedial') },
    { field: 'FSP',          headerName: 'FSP',              flex: 1, headerClassName: 'status-fsp',           valueGetter: (params) => getByStatus(params, 'FSP') },
    { field: 'Eliminated',   headerName: 'Eliminated',       flex: 1, headerClassName: 'status-eliminated',    valueGetter: (params) => getByStatus(params, 'Eliminated') },
];

function getByStatus(params, status) {
    return params.row.byStatus[status]
}

function getTotal(params) {
    // console.log('getTotal params', params)
    return Object.values(params.row.byStatus).reduce((val, accumulator) => accumulator + val, 0)
}

export default function DlspListStormAreas() {

    const [taskListWithTotals, setTaskListWithTotals] = useState([])
    const navigateToUpdateAssignee    = useNavigateWithParams('/dlsp/list_storm_areas')
    const navigateToStormAreaTaskList = useNavigateWithParams('/dlsp/storm_area_suburb_list')
    const getParams = useGetParams(['assignee'])

    // console.log('DlspListStormAreas REFRESH getParams', getParams)
    const {
        isLoading: taskSummaryLoading,
        data: taskSummaryList,
        load: loadTaskSummaryList,
        } = useFetchJson('/bff/decommissioned-lines-service/api/decommissioned-lines/summary-by-storm-area') 


    useEffect(() => {
        if (!getParams) {
            return
        }
        let params = {}
        if (getParams?.assignee) {
            params = {params: {
                    assignee: getParams.assignee
                }
            }
        }
        // console.log('DlspListStormAreas useEffect loadTaskSummaryList params', params)
        loadTaskSummaryList(params)
    }, [getParams, loadTaskSummaryList])

    useEffect(() => {
        if (!taskSummaryList) {
            return
        }

        const totalByStatus = (summaryList, statusName) => {
            const theTotal = summaryList.reduce((accumulator, element) => {
                return accumulator + (element.byStatus[statusName] || 0)
            }, 0)
            return theTotal
        }

        setTaskListWithTotals(
        [
            ...taskSummaryList,
            {
                "stormArea": "Totals",
                "byStatus": {
                    "Desktop":     totalByStatus(taskSummaryList, "Desktop"),
                    "Desktop QA":  totalByStatus(taskSummaryList, "Desktop QA"),
                    "Field":       totalByStatus(taskSummaryList, "Field"),
                    "Field QA":    totalByStatus(taskSummaryList, "Field QA"),
                    "Remedial":    totalByStatus(taskSummaryList, "Remedial"),
                    "FSP":         totalByStatus(taskSummaryList, "FSP"),
                    "Eliminated":  totalByStatus(taskSummaryList, "Eliminated")
                }
            }
        ])
    }, [taskSummaryList])

    const handleRowClick = (params, event, details) => {
        console.log('handleRowClick', {params, event, details})
        if (!params.row.stormArea || params.row.stormArea === 'Totals') {
            hikoAlert('No storm area in that row!')
            return
        }
        let navigateParams = {storm_area: params.row.stormArea}
        if (getParams?.assignee) {
            navigateParams.assignee = getParams.assignee
        }
        navigateToStormAreaTaskList(navigateParams)
    }
    
    const handleAssigneeSelected = (newAssignee) => {
        // console.log('handleAssigneeSelected newAssignee', newAssignee)
        navigateToUpdateAssignee({assignee: newAssignee})
    }

    return (
        <Box className="Page">
            <h3>Decommissioned Lines Safety Project</h3>
            <h2>Summary of all storm areas {getParams?.assignee && `for ${getParams?.assignee}`}</h2>

            <LoadingBox loading={taskSummaryLoading}>
                <Stack direction="row" sx={{justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography variant="body1">We found {(taskListWithTotals?.length - 1) || 'no'} storm area{plural((taskListWithTotals?.length - 1))}.</Typography>
                    <AssigneeSelect assignee={getParams?.assignee || ''} onChange={handleAssigneeSelected} />
                </Stack>
                <StyledDataGrid sx={{my:2}} autoHeight rows={taskListWithTotals || []}
                    getRowId={(row) => row.stormArea} columns={gridColumns}
                    onRowClick={handleRowClick}
                    // onCellClick={handleCellClick}
                />
            </LoadingBox>
            <DebugBox title="taskListWithTotals" stringify>{taskListWithTotals}</DebugBox>
        </Box>
    )
}


